import axios from "axios";
import { api } from "..";
import { ProjectService, CreateProjectService } from "../../types/domain";

export const getProjectServices = async (): Promise<ProjectService[]> => {
  const response = await axios.get(`/api/projectservices`);
  const responseDto = response.data;
  return responseDto.data.map((service: any) => {
    return {
      id: service.id,
      name: service.name,
      usageCount: service.usageCount,
      isDefault: service.isDefault,
      allowedToDelete: service.allowedToDelete
    };
  });
};

export const getProjectService = async (id: number | undefined): Promise<ProjectService> => {
  const response = await axios.get(`/api/projectservices/${id}`);
  const responseDto = response.data;
  return {
    id: responseDto.data.id,
    name: responseDto.data.name,
    usageCount: responseDto.data.usageCount,
    isDefault: responseDto.data.isDefault,
    allowedToDelete: responseDto.data.allowedToDelete
  };
};

export const createProjectService = async (projectService: CreateProjectService): Promise<string> => {
  const response = await api.post('/projectservices', projectService);
  if(response.status === axios.HttpStatusCode.Created) {
    const responseDto = response.data;
    return responseDto.data;
  }
  throw new Error(`Failed to create project service. Status: ${response.status}`);
}

export const updateProjectService = async (projectService: ProjectService): Promise<string> => {
  const response = await api.put(`/projectservices/${projectService.id}`, projectService);
  if(response.status === axios.HttpStatusCode.Ok) {
    const responseDto = response.data;
    return responseDto.data;
  }
  throw new Error(`Failed to update project service. Status: ${response.status}`);
}

export const deleteProjectService = async (id: number | undefined): Promise<void> => {
  const response = await api.delete(`/projectservices/${id}`);
  if(response.status !== axios.HttpStatusCode.NoContent) {
    throw new Error(`Failed to delete project service. Status: ${response.status}`);
  }
};
